module.exports = __webpack_public_path__ + "img/millaisia-asioita-harrastat.9bc40a9e.jpg";